<template>
  <div class="carousel">
    <van-swipe :autoplay="3000" lazy-render :loop="true" :show-indicators="false">
      <!-- <template > -->
      <van-swipe-item v-for="(item, index) in filteredBannerList" :key="index">
        <img :src="item?.url" alt="" class="carouselItem" @click="goToPath(item.redirectUrl)" />
      </van-swipe-item>
      <!-- </template> -->
    </van-swipe>
  </div>
</template>

<script setup lang="ts">
import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { computed, defineProps } from 'vue'

const { goToPath } = useNavigation()
const props = defineProps<{
  itemData: {
    banners: BannerItem[] | Record<string, BannerItem[]>
  }
}>()

const filteredBannerList = computed(() => {
  const banners = props.itemData.banners
  if (Array.isArray(banners)) return banners.filter(item => item.display)
  const lang = localStorage.getItem('lang') || 'en'
  const list = (banners as Record<string, BannerItem[]>)[lang] || (banners as Record<string, BannerItem[]>)['en'] || []
  return list.filter(item => item.display)
})
</script>
<style scoped>
.carousel {
  height: 100%;
  padding: 5px 0;
  border-radius: 15px;
}

.carouselItem {
  width: 100%;
  height: 100%;
  border-radius: 15px;
  /* object-fit: contain; */
}
</style>